import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty, parseClasses } from '../../lib/ep';
import { useCSS } from '../../lib/hooks';

import InputWithButton from './InputWithButton';
import Model from './Model';

import RibbonCollection from '../ui_items/RibbonCollection';

const ItemAsRibbons = ({ items, ...props }) => {
	useCSS('comp/input_with_ribbons.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const input_size = props?.input_size ?? null;

	const name = props?.name ?? false;
	if(name === false) return null;

	const errors = props?.errors ?? {};
	const placeholder = i18n(props?.placeholder ?? "Type to add new items");

	const has_errors = (isNotEmpty(errors, name)) ? true : false;
	const force_uppercase = props?.force_uppercase ?? true;

	const _class = parseClasses('gui_input_as_ribbons', props?._class ?? {});

	let item_ribbons = [];
	items.map((item, i) => {
		item_ribbons.push({
			title:(force_uppercase) ? item.toUpperCase() : item,
			onDelete:() => props.onDelete(i),
			confirm:false,
		});
	});

	return (
		<div class={_class}>
			<Model model={props.model} change={props.change} errors={errors}>
				<InputWithButton
					_class={{ first:true, size:input_size }}
					label_props={props.label_props}
					submitIcon={props?.icon ?? 'knk-add-item'}
					submitColor={(!has_errors) ? 'green' : 'red'}
					input_type={props.input_type}
					force_model_errors={errors?.[name] ?? false}
					name={name}
					disable_autovalidation={true}
					placeholder={placeholder}
					onSubmit={props.onSubmit}
					onChange={props.onChange}
					tooltip={props.tooltip}
					value={props.value}
					enable_key_events={false}	// we disable the submitOnEnter functionality because it's enabling to create items that are already on the list, and we didn't find a way to avoid submitting the field when we have errors
				>{props.children}</InputWithButton>
			</Model>

			{(items.length > 0) && (
				<div
					class="gui_flexbox_auto gui_overflowed_auto"
					style={{
						maxHeight:'220px',
						border:'1px solid rgba(var(--main-text-color), 0.2)',
						padding:'calc(0.2em + var(--grid-2))',
						paddingBlockEnd:'0.2em',
					}}
				>
					{(input_size != undefined && input_size < 100) && (
						<div style={{ flex:`0 0 ${100 - input_size}%` }} />
					)}

					<RibbonCollection
						_class={{other:'gui_not_in_bottom_tiny'}}
						items={item_ribbons}
					/>
				</div>
			)}
		</div>
	);
}

export default injectIntl(ItemAsRibbons);